<template>
  <form :class="`${if_selected} form-group label-floating has-warning`">
    <div>
      <div class="md-layout">
        <span class="md-layout-item note" style="white-space: normal">
          <vue-mathjax
            v-if="config.attributes.mathjax"
            :formula="tx(config.attributes.model)"
          ></vue-mathjax>
          <span
            v-else
            class="md-caption"
            v-html="tx(config.attributes.model)"
          ></span>
          <helpWidget
            v-if="this.attributes.help_img || this.attributes.help"
            class="md-layout-item pl-3"
            :help="help_key"
            :help_img="`${this.IREALCONFIG.static_ressources}/${this.attributes.help_img}.png`"
            :help_style="this.attributes.help_style"
          ></helpWidget>
        </span>
      </div>
      <!-- attributes for input possible: v-on:blur="setValue(text_value)" -->
      <input
        :step="step"
        v-model="text_value"
        class="form-control"
        :type="`${config.attributes.type}`"
        :name="`${config.attributes.name}`"
        :min="`${text_min}`"
        :max="`${text_max}`"
        :disabled="disabled"
        v-on:blur="controlTextMin"
      />
    </div>
    <Slider
      class="slider-primary mb-5"
      :id="`${this.config.attributes.model}`"
      v-model="slider_value"
      :range="range"
      :disabled="disabled"
      :step="1"
      :values="val"
    >
    </Slider>
  </form>
</template>
<script>
import { VueMathjax } from "vue-mathjax";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";
import fillins from "../fillins.js";
import Slider from "vue-material-kit-pro/src/components/Slider.vue";
import wNumb from "wnumb";
// La zone cliquable pour la selection par clic a été augmentée dans : assets/vue-material-kit-pro/src/assets/scss/material-kit/plugins
// la hauteur de l'élément noUibase (pour la classe .noUi-horizontal uniquement) est mise à 20px (zone pour selection d'une valeur par un clic proche de la barre de slide) et le noUi-connect reste à 2px - apparence de la barre de slide en orange)
export default {
  name: "slider-component",
  mixins: [inputComponentMixin],
  components: { Slider, "vue-mathjax": VueMathjax },
  data() {
    return {
      text_value: 0,
      slider_value: 0,
      slider_kit: 0,
      validate_value_min: 0,
      validate_value_max: 0,
      range: { min: 0, max: 0 },
      val: null,
      if_selected: "",
    };
  },
  watch: {
    text_value(val, oldval) {
      oldval = parseFloat(oldval);
      val = parseFloat(val);
      var index = this.list_options.indexOf(val);
      if (index < 0 && !this.is_free_text_edit) {
        var dir = val > oldval ? 1 : -1;
        var oldindex = this.list_options.indexOf(oldval);
        if (oldindex == -1) return;
        index = oldindex + dir;
        if (index < 0) index = 0;
        if (index > this.slider_max) index = this.slider_max;
        val = this.list_options[index];
      }

      this.text_value = val.toString();
      this.setValue(val, oldval);
    },

    slider_value(val, oldval) {
      // 1 --- ecouter la selection d'une nouvelle val
      // chercher la valeur correspondant à la position de la val du slider (la valeur min est du coup prise en compte)
      var newval;
      if (this.pips_slider) {
        newval = this.list_options[this.list_options.indexOf(parseFloat(val))];
      } else {
        newval = this.list_options[parseInt(val)];
      }
      if (this.list_options.indexOf(newval) >= 0) this.setValue(newval);
    },

    // rajoute une couche d'action , au value de inputmixin

    value(val) {
      this.update_values(val);
    },
  },

  created() {
    this.range.max = this.slider_max;
    this.setValue(this.value);
    this.update_values(this.value);
  },

  methods: {
    // ajout d'un forcage pour la valeur minimum ( en cas de saisie d'une valeur en dessous

    // dans le 1er input de saisie manuelle)

    controlTextMin() {
      if (this.value < this.text_min) this.value = this.text_min;
    },
    update_values(val) {
      // 3 --- mets à jour le lien text_value avec la nouvelle valeur
      // mets à jour slider_value
      if (this.pips_slider) {
        this.slider_value = val;
        this.text_value = val;
      } else {
        this.slider_value = this.list_options.indexOf(val);
        this.text_value = val;
      }
    },

    setValue(val, oldval) {
      // 2 --- enregistre la valeur selectionnée. Et attribue le bon format.
      // et envoie la mise à jour de this.value (cf. inputmixin + updateValue)
      if (this.format === "number") {
        this.value = parseFloat(val);
      } else this.value = val.toString();
    },
  },

  async mounted() {
    this.update_selected();

    Bus.$on("selected-changed", () => {
      this.update_selected();
    });
    // si l'option pips est indiquée en attribut on rajoute l'option pips de nouislider
    // l'option pips n'est pas intégrée dans material kit pro

    if (this.pips_slider) {
      var softSlider = document.getElementById(
        `${this.config.attributes.model}`
      );
      softSlider.noUiSlider.updateOptions({
        range: this.list_range,
        start: this.slider_value,
        pips: {
          mode: "positions",
          values: this.list_positions,
          density: 100,
          format: wNumb({ decimals: this.countDecimal }),
        },
        snap: true,
      });
      // add clicking pips
      var pips = softSlider.querySelectorAll(".noUi-value");
      for (var i = 0; i < pips.length; i++) {
        pips[i].style.cursor = "pointer";
        pips[i].addEventListener("click", (e) => {
          var value = Number(e.target.getAttribute("data-value"));
          this.update_values(value);
        });
      }
    } else {
      var soft = document.getElementById(`${this.config.attributes.model}`);
      soft.noUiSlider.updateOptions({
        step: this.step,
        format: wNumb({ decimals: this.countDecimal }),
      });
    }

    Bus.$on("value-changed", (payload) => {
      // for dependant slider, value is adjust ( when slider are dependants ,

      //attributes_minmodel or maxmodel represent the name of other slider )

      if (payload.param == this.config.attributes.minmodel) {
        this.validate_value_min = payload.value;
        if (this.value < this.validate_value_min || !this.value) {
          this.setValue(this.validate_value_min);
        }
      }

      if (payload.param == this.config.attributes.maxmodel) {
        this.validate_value_max = payload.value;
        if (this.validate_value_max < this.value || !this.value) {
          this.setValue(this.validate_value_max);
        }
      }
    });
  },

  computed: {
    step() {
      return parseFloat(this.config.attributes.step);
    },

    is_free_text_edit() {
      // si il n'y a pas de liste de valeur prédéfinies, on considère que
      // la suite de valeur a une incrémentation de 1 sur l'échelle [min-max]
      return this.config.attributes.options == undefined && this.step == 1;
    },

    list_options() {
      // build on array of values from min,max and step element
      return this.config.attributes.options != undefined
        ? this.config.attributes.options.split("|").map((v) => parseFloat(v))
        : fillins.xah_range(
            parseFloat(this.config.attributes.min),
            parseFloat(this.config.attributes.max),
            parseFloat(this.step)
          );
    },
    list_range() {
      var list_range = {};
      if (this.pips_slider == "border") {
        list_range["min"] = [parseFloat(this.config.attributes.min)];
        list_range["max"] = [parseFloat(this.config.attributes.max)];
        if (this.list_options) {
          for (var o in this.list_options) {
            o != 0
              ? (list_range[
                  `${
                    ((this.list_options[o] - this.config.attributes.min) /
                      (this.config.attributes.max -
                        this.config.attributes.min)) *
                    100
                  }%`
                ] = [this.list_options[o], 200])
              : "";
          }
        }
      } else {
        for (var i in this.list_positions) {
          if (i == 0) {
            list_range["min"] = [
              this.list_options[i],
              this.list_options[1] - this.list_options[i],
            ];
          } else if (i == this.list_positions.length - 1) {
            list_range["max"] = [this.list_options[i]];
          } else
            list_range[this.list_positions[i]] = [
              this.list_options[i],
              this.list_options[i] - this.list_options[i - 1],
            ];
        }
      }
      return list_range;
    },
    list_positions() {
      var tab_position = [];
      if (this.pips_slider == "border") {
        tab_position = [0, 100];
      } else {
        for (var i in this.list_options) {
          tab_position.push(
            ((this.list_options[i] - this.list_options[0]) * 100) /
              (this.list_options[this.list_options.length - 1] -
                this.list_options[0])
          );
        }
      }
      return tab_position;
    },
    countDecimal() {
      var decimal = 0;
      for (var i in this.list_range) {
        if (!Number.isInteger(this.list_range[i][0])) {
          var decimal_length = this.list_range[i][0].toString().split(".")[1];
          decimal < decimal_length.length
            ? (decimal = decimal_length.length)
            : "";
        }
      }
      return decimal;
    },
    slider_max() {
      return this.list_options.length - 1;
    },

    text_min() {
      return this.list_options[0];
    },

    text_max() {
      return this.list_options[this.list_options.length - 1];
    },

    format() {
      // return number format default because string option are rare in slider element.

      return this.config.attributes.format
        ? this.config.attributes.format
        : "number";
    },
    id_selected_tab() {
      if (this.attributes.id_selected === undefined) return [];
      else return this.attributes.id_selected.split("|");
    },
    model_dependance_tab() {
      if (this.attributes.model_dependance === undefined) return [];
      else return this.attributes.model_dependance.split("|");
    },
  },
};
</script>
<style scoped>
.note {
  color: rgba(0,0,0,0.54));
  font-size: 0.8em !important;
  font-weight: 400 !important;
  font-family: 'Roboto', sans-serif !important;
  font-style:lighter !important;
  text-align:left !important;
  display:flex;
}
.note span{
  font-style:normal !important;
}
.MathJax_Display {
  text-align: left !important;
}
#MathJax-Span{
  font-style:normal !important;
}
</style>
